import {IconButton} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const getStyle = ({isSmall, style}) => isSmall ? {right: '50%', padding: '0 12px', marginBottom: 'auto', ...style} :
  {padding: 0, marginBottom: 'auto', ...style};

export default ({onClick, isSmall, style}) => (
  <IconButton aria-label="edit" style={getStyle({isSmall, style})} onClick={onClick}>
    <EditIcon size="small" fontSize="small" color="primary"/>
  </IconButton>
);
